import {ReactNode} from "react";
import {BoxProps, Button, Divider, VStack} from "@chakra-ui/react";
import {Topic, TopicIndicator} from "../UI";
import {Request, InfoBoxItem, statuses} from "../../models";

type Item = InfoBoxItem & BoxProps
type Props = Request & {
    onClick: VoidFunction
    children?: ReactNode
    hideIndicator?: boolean
} & BoxProps;
type IndicatorProps = {bg: string; color: string; icon?: string};

const statuStyles: Record<Request["status"], IndicatorProps> = {
    approved: {bg: "customBlue.100", color: "customBlue.900", icon: "checked"},
    cancelled: {bg: "customOrange.100", color: "customOrange.900", icon: "warning"},
    declined: {bg: "red.100", color: "red.900", icon: "slash_circle"},
    open: {bg: "gray.100", color: "gray.900", icon: "pin"}
};

export function RequestItem(p: Props) {
    const items: Item[] = [
        {
            title: "Reference",
            items: [{value: p.loadID ?? "--"}]
        },
        {
            title: "Title",
            items: [
                {value: p.title}
            ]
        }
    ];
    return <VStack
        alignItems="stretch"
        bgColor="white"
        borderColor={p.borderColor ?? "grey.100"}
        borderRadius="12px"
        borderWidth="1px"
        w={{base: "full", md: "375px"}}
        p="16px 0px 12px"
        gap=".5rem"
    >
        <VStack gap=".5rem" justify="space-between" px="12px" flexDir="row" position="relative">
            <div className="topic-grid">
                {items.map((item, i) => <Topic key={i} {...item} />)}
            </div>
            <Button variant="ghost"
                className="pre-x-click"
                onClick={p.onClick}
                aria-labelledby="details_title"
                minW="24px"
                px="0"
                _hover={{background: "transparent"}}
                position="static"
            >
                <svg width="20" height="20" aria-hidden="true">
                    <use xlinkHref="#chevron_right"/>
                </svg>
                <span id="details_title" hidden>view details for request {p.requestID}</span>
            </Button>
        </VStack>
        {p.children}
        {!p.hideIndicator && <>
            <Divider background="grey.100" h="1px"/>
            <TopicIndicator
                {...statuStyles[p.status]}
                content={statuses[p.status]}
                mx="12px"
            />
        </>}
    </VStack>;
};
